import React from "react";
import {useMutation, useQuery} from "@apollo/client";
import ListTable from "../../shared/ListTable";
import {tableImageTag} from "../../../helpers/Api";
import {getClientMenus} from "../menus/MenuQueries";
import AssignMenuToClientModal from "./AssignMenuToClientModal";
import {CustomButton, EditButton} from "../../../helpers/ButtonHelper";
import {getClientById, updateClientMenuStatusMutation} from "./ClientQueries";
import Status from "../../shared/Status";
import {Link} from "react-router-dom";
import Loader from "../../shared/Loader";

const ClientMenusList = ({ client }) => {
  const { data, loading } = useQuery(getClientMenus, { variables: { clientId: client.id } })
  const [updateStatusCall] = useMutation(updateClientMenuStatusMutation, { refetchQueries: [getClientMenus, getClientById] })

  const changeStatus = (id, status) => {
    updateStatusCall({
      variables: { id: id, status: status }
    })
  }

  const header = <tr>
    <th>Denumire</th>
    <th>Status</th>
    <th># Mese</th>
    <th className='actions'>
      <AssignMenuToClientModal client={client} clientMenus={data && data.clientMenus} />
    </th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        <Link to={`/menus/${item.id}`}>
          {tableImageTag(item)}
          {item.name}
        </Link>
      </td>
      <td><Status value={item.status} /></td>
      <td>{item.platesCount}</td>
      <td className='actions'>
        <EditButton text="Personalizeaza" to={`/menus/${item.id}`}></EditButton>
        {item.status === 'active' ?
          <CustomButton icon="sign-stop" className='btn btn-danger' text='Dezactiveaza'
                        onClick={() => changeStatus(item.id, 'inactive')} />
          :
          <CustomButton icon="check" className='btn btn-success' text='Activeaza'
                        onClick={() => changeStatus(item.id, 'active')} />
        }
      </td>
    </tr>
  }

  if (loading) return <Loader />;

  return (
    <div className="row justify-content-md-center">
      {/*<PageSubTitle title='Meniuri'/>*/}
      <div className=" justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.clientMenus} header={header} listItem={listItem}
                     searchFields={['name', 'status']} />
        </div>
      </div>
    </div>
  )
};

export default ClientMenusList;
